<div class="row row-cols-1 row-cols-md-3 g-3 mt-3">
  <div class="form-group col" *ngFor="let img of imagenes; let i = index">
    
    <button type="button" class="close" aria-label="Close" (click)="quitarImg(img)"> 
      <span aria-hidden="true"><i class="fas fa-times-circle"></i></span>
    </button>

    <div class="card h-100 animated fadeIn fast imgRec">
      <a>
        <img 
          [src]="img.imageData" 
          class="card-img-top img-fluid oscurecer" 
          alt="Imagen propiedad">
      </a>

      <div class="card-footer">
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="banner-{{img.orden}}" [(ngModel)]="img.banner">
                <label class="custom-control-label" for="banner-{{img.orden}}">Banner</label>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="principal-{{img.orden}}" [(ngModel)]="img.principal">
                <label class="custom-control-label" for="principal-{{img.orden}}">Principal</label>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <input type="number" class="form-control" id="orden-{{i}}" [(ngModel)]="img.orden">
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="d-grid gap-2 d-md-flex justify-content-md-end mt-2">
  <button class="btn btn-primary me-md-2 mr-2" type="button" (click)="uploadFiles()">
    Guardar 
    <span class="badge bg-secondary" *ngIf="imagenes.length !=0">{{imagenes.length}}</span>
  </button>
  <button class="btn btn-danger" type="button" (click)="cancelar()">Cancelar</button>
</div>
